/* Public catalog values only. Do not infer fitment from product titles. */
(() => {
  const list = value => Array.isArray(value) ? value : value ? [value] : [];
  const normal = value => String(value || '').trim().replace(/\s+/g, ' ').toUpperCase();
  const categoryMap = {
    'LIFT KIT COMPONENTS & ACCESSORIES': 'components', 'BODY LIFTS': 'body', 'SUSPENSION LIFT KIT': 'lifts', 'SPACER/LEVELING LIFT KIT': 'leveling',
    'SHOCKS': 'shocks', 'BALL JOINTS': 'ball', 'COILS / STRUTS': 'coils',
    'CONTROL ARMS/TRACK BARS': 'arms', 'LEAF SPRINGS / AIR BAGS': 'leaf',
    'STEERING STABLIZER & TIE ROD / DRAG LINK': 'steering',
    'STEERING STABILIZER & TIE ROD / DRAG LINK': 'steering', 'SWAY BAR KITS / BUMP STOPS': 'sway'
  };
  const handles = {
    suspension: 'all', 'body-lifts': 'body', 'lift-kit-components-accessories': 'components', 'suspension-lift-kit': 'lifts', 'spacer-leveling-lift-kit': 'leveling',
    'shocks-1': 'shocks', 'ball-joints': 'ball', 'coils-struts': 'coils',
    'control-arms-track-bars': 'arms', 'leaf-springs-air-bags': 'leaf',
    'steering-stablizer-tie-rod-drag-link': 'steering', 'sway-bar-kits-bump-stops': 'sway'
  };
  function categories(p) {
    return [...new Set(list(p.collectionHandles).map(handle => handles[handle]).filter(group => group && group !== 'all'))];
  }
  const numberPattern = '(?:\\d+\\s+\\d+\\/\\d+|\\d+\\/\\d+|(?:\\d*\\.\\d+|\\d+))';
  const unitPattern = '(?:["″]|inch(?:es)?\\b|in\\.?\\b)';
  const measurePattern = `(?<![\\w./–—-])(${numberPattern})(?:\\s*-?\\s*(${unitPattern}))?(?:\\s*(?:-|–|—|to)\\s*(${numberPattern})(?:\\s*-?\\s*(${unitPattern}))?)?`;
  function number(value) {
    return value.trim().split(/\s+/).reduce((sum, term) => {
      if (term.includes('/')) {const [a,b]=term.split('/').map(Number);return b>0 && b<=64 && a>=0 && a<b ? sum+a/b : NaN;}
      return sum+Number(term);
    },0);
  }
  function extract(text, explicit=false, title=false) {
    text=String(text||'').replace(/''/g,'\"').replace(/\bstock\s*[-–]\s*(?=\d)/gi,'0–').replace(/[“”]/g,'"').replace(/&(?:amp|quot|nbsp);/gi,m=>({'&amp;':'&','&quot;':'"','&nbsp;':' '}[m.toLowerCase()]));
    const choices=[];
    if (/\b(?:stock|OE|factory)[- ]height\b/i.test(text) && !/\b(?:above|from|over|than|raise|increase)\b/i.test(text)) choices.push({min:0,max:0,label:'Stock height',context:text});
    for(const match of text.matchAll(new RegExp(measurePattern,'gi'))) {
      const before=text.slice(Math.max(0,match.index-60),match.index),after=text.slice(match.index+match[0].length,match.index+match[0].length+65);
      let lift=/^\s*(?:of\s+)?(?:(?:front|rear|existing|a-arm|suspension|spacer|body|coil|spring|performance|extra)\s+){0,4}(?:lift|level)/i.test(after) || /(?:lift(?:ed)?\s*(?:height|amount)(?:\s*range)?|(?:front|rear)\s*lift)\s*(?:\((?:in|inch|inches)\))?\s*:\s*$/i.test(before) || /(?:lift(?:ing)?(?: kit)?|level(?:ing)?(?: kit)?)\s*(?:by|of|:)?\s*$/i.test(before) || title && /^\s*(?:front\s*(?:&|and)\s*rear\s+)?(?:performance\s+)?suspension\b/i.test(after);
      if(title && !lift){const phrase=after.match(/^[^|,;:.\d]{0,45}\b(?:lift|leveling)\b/i);if(phrase&&!/body|diameter|travel|length|reservoir|shock size/i.test(phrase[0]))lift=true;}
      if(!explicit && !lift)continue;
      if(!match[2]&&!match[4]&&!explicit&&!/^\s+(?:lift|level)/i.test(after))continue;
      if(/\b(?:not an?|not for|does not fit|except|excluding)\b[^.;]{0,35}$/i.test(before))continue;
      const min=number(match[1]),max=match[3]?number(match[3]):min;
      if(!Number.isFinite(min)||!Number.isFinite(max)||min<0||max<min||max>20)continue;
      const label=min===max?(min===0?'Stock height':`${min}″`):`${min}–${max}″`;
      if(!choices.some(h=>h.label===label&&h.context===text))choices.push({min,max,label,context:text});
    }
    return choices;
  }
  const exempt = /\b(?:stabili[sz]er|stabli[sz]er|tie rod|drag link|bump ?stops?|sway ?bars?|ball joints?|control arms?|track bars?|boots?|roost guards?|skid plates?|steering|bushings?|isolators?|retainers?|correction (?:kit|plates?)|clamp kit|spring perch(?:es)?|spring buckets?|spring plates?|body mount kits?|mount kit,? body|shackle hangers?|(?:degree )?shims?|lowering|jounce|air springs?|air spring kit|air bags?|alignment|u-bolts?|pitman|cross ?members?|brake lines?|brake hoses?|torsion bar drop|install kit|installation kit|reservoir mounts?|shock mounts?|shock brackets?|shock extensions?|shock relocation|hardware|bumpers?|sleeves?|rebuild kit|service kit|shock guards?|limit straps?|shaft protectors?|cam washers?|compressor mounting|spring eye bolts?|shock (?:bar pin|stem) eliminator|bar pin|bash bars?|cartridge upgrade|spring center pins?|motor mount lift|shock hoops?|hoop kit|bump extension|coilover bearing|coil cup kit|coil wedges?|reservoir upgrade|reservoir w\/\s*CDCV upgrade|resi (?:CDCV )?upgrade)\b/i;
  function verifiedRecord(p) {
    const record=window.NjtVerifiedHeights?.[String(p.id)];
    return record && normal(record.vendor)===normal(p.vendor || p.brand) && list(p.variants).some(v=>record.skus.includes(v.sku)) ? record : null;
  }
  function verifiedHeights(p,record) {
    return record.heights.flatMap(h=>{
      if(!h.sku)return [h];
      const variant=list(p.variants).find(v=>v.sku===h.sku);
      return variant ? [{...h,variantId:variant.id,variant}] : [];
    });
  }
  function requiresHeight(p,groups) {
    const record=verifiedRecord(p);
    if(record?.authoritative && typeof record.requiresHeight==='boolean')return record.requiresHeight;
    const title=p.title||'';
    if(normal(p.vendor||p.brand)==='AIR LIFT' && /Air Lift 1000/i.test(title))return false;
    if(/Load Capacity/i.test(title) && /Height.*Diameter/i.test(title))return false;
    const fullKit=/\b(?:lift|suspension|leveling)\s+(?:kit|system)\b/i.test(title)&& !/\b(?:for|fits|with)\s+[^|]{0,25}(?:lift|suspension)\s+(?:kit|system)/i.test(title);
    if(exempt.test(title)&&!fullKit)return false;
    if(/\b(?:air (?:bags?|springs?)|helper springs?|load assist|load support|replacement leaves)\b/i.test(title)&& !/\blift\b/i.test(title))return false;
    return groups.some(g=>['lifts','leveling','body','shocks','coils','leaf'].includes(g)) || /\b(?:coilovers?|springs?|lift spacers?|leveling spacers?|lift blocks?|strut spacers?)\b/i.test(title);
  }
  function heights(p,groups) {
    if(!requiresHeight(p,groups))return [];
    const verified=verifiedRecord(p);
    if(verified?.authoritative)return verifiedHeights(p,verified);
    const variants=list(p.variants).flatMap(v=>list(v.options).flatMap(o=>extract(o.value,/lift height|lift size|leveling height/i.test(o.name)).map(h=>({...h,variantId:v.id,variant:v}))));
    if(variants.length)return variants;
    if(verified)return verifiedHeights(p,verified);
    const titleChoices=extract(p.title,false,true);
    const explicitSpecs=list(p.specs).filter(s=>/(?:lift(?:ed)? (?:height|amount)|(?:front|rear) lift)\s*(?:\([^)]*\))?\s*:/i.test(s)).flatMap(s=>extract(s));
    if(explicitSpecs.length)return explicitSpecs;
    const specs=list(p.specs).flatMap(s=>extract(s));
    if(specs.some(h=>/gasoline|diesel|TRD Pro|Sasquatch|factory.*air/i.test(h.context)))return specs;
    if(titleChoices.length)return titleChoices;
    if(specs.length)return specs;
    const title=p.title||'';
    const pattern=new RegExp(measurePattern,'gi');
    for(const m of title.matchAll(pattern)) {
      const before=title.slice(0,m.index),after=title.slice(m.index+m[0].length);
      let recognized=normal(p.brand)==='ICON VEHICLE DYNAMICS'&& /^\s+(?:Front|Rear)\b/i.test(after) && !/\b(?:body|travel|diameter|length)\s*$/i.test(before) || normal(p.brand)==='ROUGH COUNTRY'&& /\b(?:(?:Front|Rear) Shocks?|Loaded Strut Pair|Leveling Struts)\s*(?:Monotube\s*)?[| ]*$/i.test(before);
      if(normal(p.brand)==='ROUGH COUNTRY'&& /\b(?:M1R Reservoir Loaded Struts|M1 Adjustable Struts|Vertex 2\.5 Remote Reservoir Leveling Coilovers|Lift Shackles)\b/i.test(before)&& !/\b(?:body|travel|diameter|length)\s*$/i.test(before))recognized=true;
      if(recognized)return extract(m[0],true);
    }
    if(normal(p.brand)==='ROUGH COUNTRY'&&/(?:Loaded Strut Pair|Front Shocks|Rear Shocks|Rear Leaf Springs)\s*Stock\b/i.test(title))return [{min:0,max:0,label:'Stock height',context:''}];
    return [];
  }
  const heightGroups=[
    {value:'under-2',label:'height_under_2',min:0,max:2},
    {value:'2-under-3',label:'height_2_under_3',min:2,max:3},
    {value:'3-under-4',label:'height_3_under_4',min:3,max:4},
    {value:'4-under-6',label:'height_4_under_6',min:4,max:6},
    {value:'6-under-8',label:'height_6_under_8',min:6,max:8},
    {value:'8-plus',label:'height_8_plus',min:8,max:Infinity}
  ];
  function heightMatches(choice,value) {
    const group=heightGroups.find(g=>g.value===value);
    if(group){
      if(group.max===0)return choice.min<=0 && choice.max>=0;
      return choice.max>=group.min && choice.min<group.max;
    }
    if(value===choice.label)return true;
    const selected=value==='Stock height'?0:Number(String(value).replace(/[″"]/g,''));
    return Number.isFinite(selected)&&selected>=choice.min&&selected<=choice.max;
  }
  function forVehicle(p,vehicle) {return p.heights.filter(h=>!vehicle||!h.vehicles||h.vehicles.some(v=>normal(v)===normal(vehicle)));}
  function heightOptions(p,vehicle) {
    if(!p.requiresHeight)return [];
    if(!p.heights.length)return [];
    const choices=forVehicle(p,vehicle);
    return heightGroups.filter(group=>choices.some(h=>heightMatches(h,group.value))).map(group=>group.value);
  }
  function prepare(p, rank = 0) {
    const groups = categories(p);
    const positions = new Set();
    // Position labels take precedence; title is a fallback for explicitly named positions.
    const labelled = list(p.specs).filter(s => /(?:position|postion|location)\s*:/i.test(s)).join(' ');
    const positionText = labelled || p.title;
    if (/\bfront\b/i.test(positionText)) positions.add('front');
    if (/\brear\b/i.test(positionText)) positions.add('rear');
    const saleText = list(p.specs).join(' ');
    let unit = '';
    if (/sold\s+(?:individually|as\s+(?:a\s+)?single|as\s+each)/i.test(saleText)) unit = 'individual';
    else if (/sold\s+(?:as|in)\s+(?:a\s+)?pairs?\b/i.test(saleText)) unit = 'pair';
    return {...p, rank, groups, requiresHeight:requiresHeight(p,groups), heights:heights(p,groups), positions:[...positions], unit,
      vehicles:list(p.vehicles).map(normal), brand:String(p.brand || ''),
      inStock:p.liveInventory === true ? p.hasStock === true : p.available === true};
  }
  function category(url) {
    return handles[url.pathname.split('/').filter(Boolean).pop()] || 'all';
  }
  function matches(p, state, skip) {
    if (state.vehicle && !p.universal && !p.vehicles.includes(normal(state.vehicle))) return false;
    if (state.category !== 'all' && !p.groups.includes(state.category)) return false;
    if (skip !== 'brand' && state.brands.length && !state.brands.some(b => normal(b) === normal(p.brand))) return false;
    if (skip !== 'height' && state.heights.length && !state.heights.some(h => forVehicle(p,state.vehicle).some(choice => heightMatches(choice,h)))) return false;
    if (skip !== 'position' && state.positions.length && !state.positions.some(v => p.positions.includes(v))) return false;
    const scopedHeights=forVehicle(p,state.vehicle);
    const selectedVariants=(state.heights.length && skip!=='height' ? scopedHeights.filter(h=>state.heights.some(value=>heightMatches(h,value))) : scopedHeights).filter(h=>h.variant).map(h=>h.variant);
    const candidates=selectedVariants.length?selectedVariants:list(p.variants);
    if(candidates.length){
      if(!candidates.some(v=>(skip==='availability'||!state.stock||(p.liveInventory?v.stock>0:v.available))&&(skip==='price'||state.min===''||v.price>=Number(state.min)*100)&&(skip==='price'||state.max===''||v.price<=Number(state.max)*100)))return false;
    }else{
      if(skip!=='availability'&&state.stock&&!p.inStock)return false;
      if(skip!=='price'&&state.min!==''&&p.price<Number(state.min)*100)return false;
      if(skip!=='price'&&state.max!==''&&p.price>Number(state.max)*100)return false;
    }
    return true;
  }
  window.NjtSuspensionModel = {prepare,matches,category,normal,handles,heightMatches,heightOptions,heightGroups,extract,forVehicle};
})();
